export default ({ data }) => {
  const {
    desc,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    termsType,
    freeText,
  } = data;
  return (
    <div
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
      }}
    >
      <div
        style={{
          height: 35,
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <div
          style={{
            width: 16,
            height: 16,
            borderRadius: 2,
            border: "1px solid #cccccc",
          }}
        ></div>
        <div>
          {termsType === "popup" ? (
            desc
          ) : (
            <div
              style={{ textAlign: "left" }}
              dangerouslySetInnerHTML={{ __html: freeText }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
